// LMS Conflict Model

import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty, type FirestoreLMSConflict } from '../firestore/LMSConflict'
import type { FirebaseRepository } from './FirebaseRepository'

export class LMSConflict extends ObservableModelWithDecorators<FirestoreLMSConflict> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreLMSConflict>
  ) {
    super(repository, doc)
  }
}
